import React from 'react';
import { cn } from './cn';

/** Selection actions replace mobile bottom navigation and remain in flow on desktop. */
export default function BulkActionsBar({ children, className }) {
    return (
        <div
            role="toolbar"
            aria-label="Selection actions"
            className={cn(
                'fixed inset-x-0 bottom-0 z-40 flex items-center justify-around gap-1 border-t border-bun-line bg-bun-surface px-2 py-2 pb-[max(8px,env(safe-area-inset-bottom))] font-instrument [&>button]:flex-col [&>button]:px-1 [&>button]:text-bun-meta [&>div>button]:flex-col [&>div>button]:px-1 [&>div>button]:text-bun-meta lg:static lg:flex-wrap lg:justify-start lg:gap-2 lg:rounded-bun-lg lg:border lg:p-3 lg:[&>button]:flex-row lg:[&>button]:px-3 lg:[&>div>button]:flex-row lg:[&>div>button]:px-3',
                className
            )}
        >
            {children}
        </div>
    );
}
